import QRCode from "react-qr-code";
import "./styles.css";
import { useTranslation } from "react-i18next";
import { useEffect } from "react";
import { useAmplitude } from "../../context/AmplitudeContext";

export const DesktopPage = () => {
  const { t } = useTranslation("homeModule");
  const trackEvent = useAmplitude();

  // Track desktop QR-code visits
  useEffect(() => {
    trackEvent("webapp_user_visited_desktop_page");
  }, [trackEvent]);

  const getQRValue = () => {
    const searchParam = new URLSearchParams(window.location.search);
    searchParam.set("scanned", true);
    const newSearchString = searchParam.toString();
    const newUrl = `${window.location.origin}${window.location.pathname}?${newSearchString}`;
    return newUrl;
  };

  return (
    <>
      <div className="desktop-info">
        <h2 className="desktop-title">{t("desktop-title")}</h2>
        <p className="desktop-detail">{t("desktop-detail")}</p>
        <QRCode
          style={{
            height: "40vmin",
            width: "40vmin",
            maxWidth: "200px",
            maxHeight: "200px",
            marginTop: "3rem",
          }}
          bgColor="var(--color-background)"
          value={getQRValue()}
          level="M"
        />
      </div>
      <div className="source-logo">
        <p className="source-text">{t("logo-power")}</p>
        <img src="iqonic-logo.png" alt={"IQONIC.AI"} width={100} />
      </div>
    </>
  );
};
